import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled, {css} from 'styled-components';

import {Renderer} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {CrmSyncDialogStepHeader} from './crmSyncDialogStepHeader';

/*
 * Props.
 */

interface CrmSyncDialogStepProps {
  step: number;
  title?: ReactNode;
  description?: ReactNode;
  isDisabled?: boolean;
  isLoading?: boolean;
  renderLoadingState?: Renderer;
}

/*
 * Style.
 */

const StyledStepWrapperDiv = styled.div`
  padding: 20px;
  border-top: 1px solid ${(p) => p.theme.greys.shade30};

  &:first-child {
    border-top: none;
  }
`;

interface StyledStepContentWrapperDivProps {
  $isDisabled?: boolean;
}

const StyledStepContentWrapperDiv = styled.div<StyledStepContentWrapperDivProps>`
  ${(p) =>
    p.$isDisabled &&
    css`
      opacity: 0.4;
    `}
`;

const StyledStepContentDiv = styled.div``;

/*
 * Component.
 */

export const CrmSyncDialogStep: FC<PropsWithChildren<CrmSyncDialogStepProps>> = (props) => {
  const {
    step,
    title,
    description,
    isDisabled,
    isLoading,
    children,
    renderLoadingState: renderLoading,
  } = props;
  if (isLoading) {
    return renderLoadingState(description, renderLoading);
  }
  return (
    <StyledStepWrapperDiv>
      <StyledStepContentWrapperDiv $isDisabled={isDisabled}>
        <CrmSyncDialogStepHeader step={step} title={title} description={description} />
        <StyledStepContentDiv>{children}</StyledStepContentDiv>
      </StyledStepContentWrapperDiv>
    </StyledStepWrapperDiv>
  );
};

/*
 * Helpers.
 */

function renderLoadingState(description?: ReactNode, renderLoading?: Renderer) {
  return (
    <StyledStepWrapperDiv>
      <CrmSyncDialogStepHeader isLoading description={description} />
      {renderLoading && <StyledStepContentDiv>{renderLoading()}</StyledStepContentDiv>}
    </StyledStepWrapperDiv>
  );
}
